export default __webpack_public_path__ + "static/media/Riflessi_del_tramonto_Lucas_30_x_40.e5362888.jpg";